import React from "react";
import { Moon, Heart, RefreshCw } from "lucide-react";
import PainLandingPage from "@/pages/PainLandingPage";

const ReconnectPage = () => (
  <PainLandingPage
    ns="reconnect"
    variant="soft"
    photo="/assets/lifestyle/couple-story.jpg"
    icons={[<Moon size={20} />, <Heart size={20} />, <RefreshCw size={20} />]}
  />
);

export default ReconnectPage;
